export default __webpack_public_path__ + "static/media/kayaguneri1.33c46b23.jpg";